import { MainContainer } from '#app/shared/ui/layout/MainContainer.js'
import { SliderRangeInput } from './SliderRangeInput'

interface FilterKmAnosProps {
  maxMileage?: number
  minYear?: number
}

export const FilterKmAnos = ({
  maxMileage = 200000,
  minYear = 2013,
}: FilterKmAnosProps) => {
  const currentYear = new Date().getFullYear()

  const maxInKm = maxMileage / 1000
  const dynamicMaxKm = Math.ceil(maxInKm / 50) * 50
  const dynamicMax = dynamicMaxKm * 1000

  return (
    <MainContainer>
      <div
        className={`
          flex w-full flex-col justify-between gap-6 px-2 py-4

          lg:flex-row lg:gap-24
        `}
      >
        <SliderRangeInput
          title="Kilómetros"
          minParamName="kmMin"
          maxParamName="kmMax"
          min={0}
          max={dynamicMax}
          step={10000}
          suffix=" km"
          formatValue={(value) => `${value.toLocaleString()} km`}
        />

        <SliderRangeInput
          title="Años"
          minParamName="yearMin"
          maxParamName="yearMax"
          min={minYear}
          max={currentYear}
          step={1}
        />
      </div>
    </MainContainer>
  )
}
